export class TranslationBundle {
    translations = {};
    constructor(translations) {
        if (translations) {
            //avoid stacking translations object when a TranslationBundle is initialized with a TranslationBundle
            this.translations = translations.translations ? translations.translations : translations;
        }
    }
}
